export const sections = [
  { title: 'Home', href: '#home' },
  { title: 'About', href: '#about' },
  { title: 'Projects', href: '#projects' },
  { title: 'Timeline', href: '#timeline' },
  { title: 'Contact', href: '#contact' },
];

export const about = {
  description: [
    'Hello! My name is Minh. I am currently in Computer Programmer Analyst program at St. Lawrence College and I am graduating at the end of April 2022. I am passionate about things related to technology, especially the Web Development.',
    'I would love the opportunity to learn and work alongside other like-minded professionals who are all collaborating to build the best website and software possible that meets the ever-changing needs of the end-user.',
  ],
};

export const experiences = [
  {
    position: 'Front-end Web Developer Intern',
    company: 'Taubyte | Remote',
    description: [
      'Develop Taubyte websites using HTML5, CSS, Sass, JavaSript, and Vue.js.',
      'Troubleshot and debugged code ensuring a good user experience.',
      'Use Jira and Bitbucket to efficiently collaborate with other developers and track bugs.',
    ],
    time: 'Sep 2021 - Present',
  },
];

export const educations = [
  {
    school: 'St. Lawrence College | Kingston, ON',
    program: 'Computer Programmer Analyst',
    time: 'Expected April 2022',
    coursework:
      'Relevant Coursework: MySQL, C++, Program Design, Linux, NodeJS, Web Services.',
  },
  {
    school: 'Udemy, Inc | Online Learning Platform',
    program: 'Web Development',
    time: 'Present',
    coursework:
      'Completed courses: Python, JavaScript, React.js, Website Development.',
    course: [
      {
        name: 'JavaScript',
        url: 'https://www.udemy.com/certificate/UC-601a7828-0855-4603-8cfa-0efb05b791dd/',
      },
      {
        name: 'React',
        url: 'https://www.udemy.com/certificate/UC-3283f98d-3117-4897-8468-5703b33aae1e/',
      },
      {
        name: 'Web Development',
        url: 'hhttps://www.udemy.com/certificate/UC-3ab6d5f2-e2ac-400c-ae65-a5e040df9053/',
      },
      {
        name: 'Python',
        url: 'https://www.udemy.com/certificate/UC-9b0dbc6e-c1b1-4620-aace-85ceed2608e1/',
      },
    ],
  },
  {
    school: 'University of Information Technology | Viet Nam',
    program: 'Information Technology',
    time: 'August 2017 - January 2018',
    coursework:
      'Relevant Coursework: Introduction to Programming(C++), Python, Calculus.',
  },
];

export const contact = {
  phone: '+1 (613)-453-6449',
  email: 'minhtu.ngo1999@gmail.com',
};

export const projects = [
  {
    title: 'Real Time Chat app',
    description: 'A small chat room application.',
    tech: ['React', 'Node.js', 'Socket.io'],
    liveURL: 'https://minh-chat-app.netlify.app/',
    github: 'https://github.com/minhtungo/realtime-chat-app',
    image: '/images/realtime-chat.png',
  },
  {
    title: 'Cooking Recipe app',
    description: 'A small app to add/save/edit your secret cooking recipe.',
    tech: ['React', 'Firebase'],
    liveURL: 'https://minh-cooking-recipe.netlify.app',
    github: 'https://github.com/minhtungo/cooking-recipe',
    image: '/images/cooking-app.png',
  },
  {
    title: 'My Blog',
    description: 'A small blog app built with Next.js, Sanity.',
    tech: ['React', 'Next', 'Sanity', 'TypeScript'],
    liveURL: 'https://my-small-blog.vercel.app/',
    github: 'https://github.com/minhtungo/my-small-blog',
    image: '/images/blog.png',
  },
  {
    title: 'Calculator',
    description: 'Built a simple calculator using React.js.',
    tech: ['React'],
    liveURL: 'https://minhcalculator.netlify.app/',
    github: 'https://github.com/minhtungo/calculator-react-app',
    image: '/images/calculator.png',
  },
  {
    title: 'My Portfolio',
    description: 'My Portfolio',
    tech: ['React', 'Styled Components', 'React Bootstrap'],
    liveURL: 'https://minhtungo.com/',
    github: 'https://github.com/minhtungo/realtime-chat-app',
    image: '/images/my-porfolio.png',
  },
  {
    title: 'Tesla Landing Page Clone',
    description: 'Clone Tesla landing page.',
    tech: ['React', 'Styled Components'],
    liveURL: 'https://minh-tesla-clone.netlify.app',
    github: 'https://github.com/minhtungo/Tesla-Landing-Page-clone',
    image: '/images/tesla-clone.png',
  },
  {
    title: 'Matching game',
    description: 'A simple memory game built with React.',
    tech: ['React', 'Styled Components'],
    liveURL: 'https://minh-memory-game.netlify.app',
    github: 'https://github.com/minhtungo/matching-game',
    image: '/images/memory-game.png',
  },
  {
    title: 'Pho Chopstix',
    description: 'Built a responsive website for a local restaurant.',
    tech: ['React', 'Styled Components', 'React Bootstrap'],
    liveURL: 'https://phochopstix.ca/',
    github: 'https://github.com/minhtungo/Pho-Chopstix',
    image: '/images/phochopstix.png',
  },

  {
    title: 'Wordle clone',
    description: 'Clone the Wordle game built with JavaScript',
    tech: ['HTML', 'CSS', 'JavaScript'],
    liveURL: 'https://minh-worldle-clone.netlify.app',
    github: 'https://github.com/minhtungo/Wordle-Game-Clone',
    image: '/images/wordle.png',
  },
  {
    title: 'Todo List app',
    description: 'A simple todo app to learn TypeScript.',
    tech: ['React', 'TypeScript'],
    liveURL: 'https://minh-todo-ts.netlify.app',
    github: 'https://github.com/minhtungo/Todo-app',
    image: '/images/todo-ts.png',
  },
  {
    title: 'Weather app',
    description: 'A simple weather app using Weatherstack API.',
    tech: ['JavaScript', 'HTML', 'CSS'],
    liveURL: 'https://minh-weather-application.herokuapp.com/',
    github: 'https://github.com/minhtungo/Weather-App',
    image: '/images/weather.png',
  },
];
